// Helpers for PUT /products/<id>/inventory (MCS-5).
// Kept free of imports so they can be exercised without the webpack aliases.

export const STALE_QUANTITY_CODE = 'CHANGE_FROM_QUANTITY_STALE'

const lastSegment = (id) => (typeof id === 'string' ? id.split('/').pop() : String(id))

export const sameShopifyId = (a, b) => a !== undefined && a !== null && lastSegment(a) === lastSegment(b)

// Returns the input as a non-negative integer, or null when it is not one.
// Never let "" or a decimal reach the backend: it rejects them with a 400.
export function parseQuantity(value) {
    if (typeof value === 'number') {
        return Number.isInteger(value) && value >= 0 ? value : null
    }
    if (typeof value !== 'string' || !/^\s*\d+\s*$/.test(value)) {
        return null
    }
    return parseInt(value, 10)
}

// Looks up the quantity Shopify reported in a 409 for one inventory item at one location.
export function findCurrentQuantity(currentQuantities, inventoryItemId, locationId) {
    const match = (currentQuantities || []).find(
        q => sameShopifyId(q.inventoryItemId, inventoryItemId) && sameShopifyId(q.locationId, locationId)
    )
    return match ? match.quantity : undefined
}

// Classifies an axios error from inventory.update into what the UI needs to show.
export function parseInventoryError(error) {
    const response = error && error.response
    const data = (response && response.data) || {}
    if (response && response.status === 409 && data.code === STALE_QUANTITY_CODE) {
        return {stale: true, currentQuantities: data.currentQuantities || null}
    }
    if (response && response.status === 400 && data.errors) {
        // {"quantities": {"0": {"quantity": ["Not a valid integer."]}}}, keyed by request index.
        const quantityErrors = (data.errors.quantities && data.errors.quantities[0]) || {}
        const fieldErrors = [].concat(...Object.values(quantityErrors))
        const otherErrors = flattenMessages(data.errors).filter(m => !fieldErrors.includes(m))
        return {stale: false, fieldErrors, message: otherErrors.join(' ') || null}
    }
    if (response && Array.isArray(data.message)) {
        return {stale: false, fieldErrors: [], message: data.message.map(e => e.message || e).join(' ')}
    }
    return {stale: false, fieldErrors: [], message: null}
}

function flattenMessages(errors) {
    if (Array.isArray(errors)) return errors.map(String)
    if (errors && typeof errors === 'object') return [].concat(...Object.values(errors).map(flattenMessages))
    return errors ? [String(errors)] : []
}

export const INVALID_QUANTITY_MESSAGE = 'Bitte eine ganze Zahl ab 0 eingeben.'

export function staleQuantityMessage(currentQuantity) {
    const current = currentQuantity === undefined ? '' : ` (aktuell: ${currentQuantity})`
    return `Der Lagerbestand wurde seit dem Laden geändert${current}. Bitte prüfen und erneut speichern.`
}
